export default __webpack_public_path__ + "static/media/collection-cover-1.d279a874.png";